import Loading from 'views/components/common/Loading/Loading';

export default Loading;
